import { render } from "./omo.vue?vue&type=template&id=e49e2e12&scoped=true&ts=true"
import script from "./omo.vue?vue&type=script&lang=ts"
export * from "./omo.vue?vue&type=script&lang=ts"

import "./omo.vue?vue&type=style&index=0&id=e49e2e12&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e49e2e12"]])

export default __exports__